__turbopack_context__.v({
  "alert": "CrmModule-module__5p7Q_a__alert",
  "badge": "CrmModule-module__5p7Q_a__badge",
  "description": "CrmModule-module__5p7Q_a__description",
  "featureIcon": "CrmModule-module__5p7Q_a__featureIcon",
  "featureItem": "CrmModule-module__5p7Q_a__featureItem",
  "featureList": "CrmModule-module__5p7Q_a__featureList",
  "floatMockup": "CrmModule-module__5p7Q_a__floatMockup",
  "ghostCursor": "CrmModule-module__5p7Q_a__ghostCursor",
  "ghostDragCard": "CrmModule-module__5p7Q_a__ghostDragCard",
  "ghostFakeCard": "CrmModule-module__5p7Q_a__ghostFakeCard",
  "ghostInteractionArea": "CrmModule-module__5p7Q_a__ghostInteractionArea",
  "ghostMove": "CrmModule-module__5p7Q_a__ghostMove",
  "kActionBtn": "CrmModule-module__5p7Q_a__kActionBtn",
  "kActions": "CrmModule-module__5p7Q_a__kActions",
  "kAddBtn": "CrmModule-module__5p7Q_a__kAddBtn",
  "kAvatar": "CrmModule-module__5p7Q_a__kAvatar",
  "kBtnOrange": "CrmModule-module__5p7Q_a__kBtnOrange",
  "kCard": "CrmModule-module__5p7Q_a__kCard",
  "kCardFooter": "CrmModule-module__5p7Q_a__kCardFooter",
  "kCardList": "CrmModule-module__5p7Q_a__kCardList",
  "kCardMain": "CrmModule-module__5p7Q_a__kCardMain",
  "kCardProfile": "CrmModule-module__5p7Q_a__kCardProfile",
  "kColCount": "CrmModule-module__5p7Q_a__kColCount",
  "kColHeader": "CrmModule-module__5p7Q_a__kColHeader",
  "kColMoney": "CrmModule-module__5p7Q_a__kColMoney",
  "kColTitle": "CrmModule-module__5p7Q_a__kColTitle",
  "kColTitleRow": "CrmModule-module__5p7Q_a__kColTitleRow",
  "kDot": "CrmModule-module__5p7Q_a__kDot",
  "kFilter": "CrmModule-module__5p7Q_a__kFilter",
  "kFooterIcon": "CrmModule-module__5p7Q_a__kFooterIcon",
  "kFunnelIcon": "CrmModule-module__5p7Q_a__kFunnelIcon",
  "kFunnelTitle": "CrmModule-module__5p7Q_a__kFunnelTitle",
  "kName": "CrmModule-module__5p7Q_a__kName",
  "kNotification": "CrmModule-module__5p7Q_a__kNotification",
  "kPhone": "CrmModule-module__5p7Q_a__kPhone",
  "kSlaHeader": "CrmModule-module__5p7Q_a__kSlaHeader",
  "kTag": "CrmModule-module__5p7Q_a__kTag",
  "kTagBad": "CrmModule-module__5p7Q_a__kTagBad",
  "kTagGood": "CrmModule-module__5p7Q_a__kTagGood",
  "kTagWarn": "CrmModule-module__5p7Q_a__kTagWarn",
  "kTags": "CrmModule-module__5p7Q_a__kTags",
  "kTopLeft": "CrmModule-module__5p7Q_a__kTopLeft",
  "kTopRight": "CrmModule-module__5p7Q_a__kTopRight",
  "kValue": "CrmModule-module__5p7Q_a__kValue",
  "kanbanBoard": "CrmModule-module__5p7Q_a__kanbanBoard",
  "kanbanColumn": "CrmModule-module__5p7Q_a__kanbanColumn",
  "kanbanMockup": "CrmModule-module__5p7Q_a__kanbanMockup",
  "kanbanTopBar": "CrmModule-module__5p7Q_a__kanbanTopBar",
  "mockupContainer": "CrmModule-module__5p7Q_a__mockupContainer",
  "moduleWrapper": "CrmModule-module__5p7Q_a__moduleWrapper",
  "pulseGlow": "CrmModule-module__5p7Q_a__pulseGlow",
  "pulseSla": "CrmModule-module__5p7Q_a__pulseSla",
  "textContent": "CrmModule-module__5p7Q_a__textContent",
  "title": "CrmModule-module__5p7Q_a__title",
});
